/** Vier Farben aus der Freuden-Palette, stabil pro Bezeichnung — gleiches Angebot, gleiche Farbe. */
export const joyColorClass = (label: string): string => {
  let hash = 0;
  for (let i = 0; i < label.length; i++) {
    hash = (hash * 31 + label.charCodeAt(i)) % 997;
  }
  return `--c${(hash % 4) + 1}`;
};
